package com.essntl.core.whatsapp.data.response

import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiMessagesResponseDto(
    val messages: List<WhapiMessageDto>
)
